var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M60,20H48V4c0-2.211-1.789-4-4-4H20c-2.211,0-4,1.789-4,4v6H4c-2.211,0-4,1.789-4,4v46c0,2.211,1.789,4,4,4 h56c2.211,0,4-1.789,4-4V24C64,21.789,62.211,20,60,20z M16,62H4c-1.104,0-2-0.896-2-2V14c0-1.104,0.896-2,2-2h12V62z M35,62.002 h-6V54h6V62.002z M46,62l-0.001,0.002H37V53c0-0.553-0.447-1-1-1h-8c-0.553,0-1,0.447-1,1v9.002h-8.999L18,62V4 c0-1.104,0.896-2,2-2h24c1.104,0,2,0.896,2,2V62z M62,60c0,1.104-0.896,2-2,2H48V22h12c1.104,0,2,0.896,2,2V60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M7,24h4c0.553,0,1-0.447,1-1v-4c0-0.553-0.447-1-1-1H7c-0.553,0-1,0.447-1,1v4C6,23.553,6.447,24,7,24z  M8,20h2v2H8V20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M7,34h4c0.553,0,1-0.447,1-1v-4c0-0.553-0.447-1-1-1H7c-0.553,0-1,0.447-1,1v4C6,33.553,6.447,34,7,34z  M8,30h2v2H8V30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M7,44h4c0.553,0,1-0.447,1-1v-4c0-0.553-0.447-1-1-1H7c-0.553,0-1,0.447-1,1v4C6,43.553,6.447,44,7,44z  M8,40h2v2H8V40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M29,18h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C30,18.447,29.553,18,29,18 z M28,22h-2v-2h2V22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M29,28h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C30,28.447,29.553,28,29,28 z M28,32h-2v-2h2V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M29,38h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C30,38.447,29.553,38,29,38 z M28,42h-2v-2h2V42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M39,18h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C40,18.447,39.553,18,39,18 z M38,22h-2v-2h2V22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M29,8h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1V9C30,8.447,29.553,8,29,8z  M28,12h-2v-2h2V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M39,8h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1V9C40,8.447,39.553,8,39,8z  M38,12h-2v-2h2V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M39,28h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C40,28.447,39.553,28,39,28 z M38,32h-2v-2h2V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M39,38h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C40,38.447,39.553,38,39,38 z M38,42h-2v-2h2V42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M57,28h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C58,28.447,57.553,28,57,28 z M56,32h-2v-2h2V32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M57,38h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C58,38.447,57.553,38,57,38 z M56,42h-2v-2h2V42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M57,48h-4c-0.553,0-1,0.447-1,1v4c0,0.553,0.447,1,1,1h4c0.553,0,1-0.447,1-1v-4C58,48.447,57.553,48,57,48 z M56,52h-2v-2h2V52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M7,54h4c0.553,0,1-0.447,1-1v-4c0-0.553-0.447-1-1-1H7c-0.553,0-1,0.447-1,1v4C6,53.553,6.447,54,7,54z  M8,50h2v2H8V50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2);
export default __webpack_public_path__ + "static/media/building2.ca10877bd4d41dd1bbff4707073e1352.svg";
export { ForwardRef as ReactComponent };